import React from 'react';
import { Typography } from '@material-ui/core';
import { SectionWrapper, SectionTitle } from './index';
import { convertToLocalTime } from '../../../../utils';

const AuctionEndTimeSection = ({ dateEnd }) => (
  <SectionWrapper className="vehicle-condition">
    <SectionTitle>Auction End Time</SectionTitle>
    <Typography>{convertToLocalTime(dateEnd)}</Typography>
  </SectionWrapper>
);

export default AuctionEndTimeSection;
